// What the Calendar keeps in this browser between visits: which layers were on, what they were called,
// each site's name and logo. It names people (a shared calendar is often someone's address) and
// businesses, so it belongs to the account that saw it: every key carries the user, nothing is read
// for anyone else, and sign-out drops it all.

const PREFIX = 'symphony.calendar.';

const keyFor = (name: string, userId: string) => `${PREFIX}${userId}.${name}`;

/** The stored value, or undefined when there is none, no user yet, or storage is blocked. */
export function readCalendarStore<T>(name: string, userId: string | undefined): T | undefined {
  if (!userId) return undefined;
  try {
    const raw = window.localStorage.getItem(keyFor(name, userId));
    return raw ? (JSON.parse(raw) as T) : undefined;
  } catch {
    return undefined;
  }
}

export function writeCalendarStore(name: string, userId: string | undefined, value: unknown): void {
  if (!userId) return;
  try {
    window.localStorage.setItem(keyFor(name, userId), JSON.stringify(value));
  } catch {
    // Private windows and blocked storage just start from nothing next time.
  }
}

/** Everything the Calendar stored, for every account — the sign-out boundary. */
export function clearCalendarStorage(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (key?.startsWith(PREFIX)) keys.push(key);
    }
    for (const key of keys) window.localStorage.removeItem(key);
  } catch {
    // Nothing to clear when storage is blocked.
  }
}
